const INITIAL_STATE = {}

export default function errors(state = INITIAL_STATE, action){
  if(action.type === "SET_ERRORS")
    return action.errors;
  return state;
}